export default {
  core: {
    list: {
      next: "Next",
      previous: "Previous"
    },
    notFoundErrorMessage: "This entity could not be found.",
    serverErrorMessage: "There was an error on the server.",
    tagline: "HIGH-PRECISION",
    tagline2: " BLOCK EXPLORER",
    networkOptions: {
      eos_mainnet: "EOS MAINNET",
      eos_kylin: "KYLIN TESTNET",
      eos_eosio: "EOSIO TESTNET"
    },
    by: "By",
    newVersionAvailable: "A NEW VERSION OF EOSQ IS AVAILABLE, PLEASE ",
    refresh: "REFRESH",
    menu: {
      mainTitle: "MENU",
      titles: {
        network: "NETWORKS",
        testnetNetwork: "TESTNETS",
        navigation: "NAVIGATION",
        language: "LANGUAGE"
      }
    }
  }
}
